// extracted by mini-css-extract-plugin
export default {"box":"detail_box__LwygZ","subTitle":"detail_subTitle__o3bLJ","field":"detail_field__IkKrZ","flexBox":"detail_flexBox__UxXzo","fix":"detail_fix__xMVoJ"};